import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'

export default function GoalsFeedbackPage() {
  const { t } = useTranslation()

  return (
    <FeedbackPage
      emoji="🌟"
      heading={t('pages.onboarding.goalsFeedback.heading')}
      text={t('pages.onboarding.goalsFeedback.text')}
      onSubmit={() => {}}
    />
  )
}
